import React, { FC } from 'react';
import { Export } from '@fabric-ui/icons';
import { noop } from '@fabric-ui/utils';
import { AvButton, AvTooltip } from './';

interface ExportButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  width?: number;
  exportLimit?: number;
  totalRowsCount?: number;
  customTooltipText?: string;
  showToolbarOnDisabled?: boolean;
}

const ExportButton: FC<ExportButtonProps> = ({
  disabled,
  loading,
  onClick = noop,
  width = 20,
  exportLimit = Infinity,
  totalRowsCount = 100,
  customTooltipText = `Export ${totalRowsCount > exportLimit ? `first ${exportLimit.toLocaleString()} values ` : ''}as CSV`,
  showToolbarOnDisabled = false,
}) => (
  <AvTooltip title={customTooltipText} disabled={!showToolbarOnDisabled && disabled}>
    <div>
      <AvButton disabled={disabled} variant="filter" className="transparent" sx={{ px: 1 }} loading={loading} onClick={onClick}>
        <Export style={{ width, height: width }} />
      </AvButton>
    </div>
  </AvTooltip>
);
export { ExportButton };
